import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';

/** Read-only; only shown when the loan belongs to a master note. */
export const MasterNoteBfiNumberField = () => {
    const masterNoteBfiNumber = useStandardLoanStore((state) => state.setupLoanContext.masterNoteBfiNumber);

    if (!masterNoteBfiNumber) {
        return null;
    }

    return (
        <TextBox
            id='setupMasterNoteBfiNumber'
            value={masterNoteBfiNumber}
            label='Master Note BFI #'
            readOnly={true}
            width='100%'
            height='36px'
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
